//component entry file
const common= require("./utils/common");
const downloadUtils = require("./utils/downloadUtils");
const localStorage = require("./utils/localStorage");
const riskPortrait = require("./utils/riskPortrait");
const apiCommon = require( "./api/common");
const search = require( "./utils/search");
const exportFile= require("./components/mixin/exportFile")
const searchBox= require("./components/mixin/searchBox")
import request from "./utils/request"
import Head from "./components/common/Head.vue"
import { getENV } from './env.js'
const componentsCommon={
    getENV,
    apiCommon,
    common,
    downloadUtils,
    localStorage,
    request,
    riskPortrait,
    search,
    mixin:{
        exportFile,
        searchBox
    },
    Head
};

const TAG = {
    VERSION: window.VERSION,
    COMMIT: window.COMMIT,
    BRANCH: window.BRANCH,
    TIMESTAMP:window.TIMESTAMP
};

console.log(TAG);

export default componentsCommon;